export function normalizeContractNumber(value: string): string {
  return value.trim();
}

export function toPathSegment(contractNumber: string): string {
  return encodeURIComponent(normalizeContractNumber(contractNumber));
}

export function fromPathSegment(segment: string): string {
  return decodeURIComponent(segment);
}
